import Bomb from '../assets/icons/bomb.svg';
import BombExplode from '../assets/icons/bomb-explode.svg';
import Flag from '../assets/icons/flag.svg';
import FlagMissed from '../assets/icons/flag-missed.svg';
import QuestionMark from '../assets/icons/question-mark.svg';
import UnopenedSquare from '../assets/icons/unopened-square.svg';
import Number0 from '../assets/icons/number-0.svg';
import Number1 from '../assets/icons/number-1.svg';
import Number2 from '../assets/icons/number-2.svg';
import Number3 from '../assets/icons/number-3.svg';
import Number4 from '../assets/icons/number-4.svg';
import Number5 from '../assets/icons/number-5.svg';
import Number6 from '../assets/icons/number-6.svg';
import Number7 from '../assets/icons/number-7.svg';
import Number8 from '../assets/icons/number-8.svg';
// @ Alias is currently not supported due to tsc or tsc-alias

export default {
  Bomb,
  BombExplode,
  Flag,
  FlagMissed,
  QuestionMark,
  UnopenedSquare,
  Number0,
  Number1,
  Number2,
  Number3,
  Number4,
  Number5,
  Number6,
  Number7,
  Number8,
};
